import { Action } from '../actions';
import { UPDATE_CLIENT_DEV_INFO } from '../actions/development-tools';
import { UPDATE_DEV_INFO } from '../actions/devInfo';
import { DevInfo } from '../typings/dev';
import { State } from '../typings/state';

export const defaultDevInfo: DevInfo = {
    isBeta: process.env.NODE_ENV !== 'production',
    isProduction: process.env.NODE_ENV === 'production',
    svn: {
        branch: 'none',
        revision: 0
    },
    betaNumber: 'localhost',
    dbInfo: {
        configuration: '',
        shard: ''
    },
    clientId: '',
    role: '',
    operatorFeatures: [],
    clientFeatures: []
};

export function devInfo(state: DevInfo = defaultDevInfo, action: Action, fullState: State): DevInfo {
    switch (action.type) {
        case UPDATE_DEV_INFO: {
            return {
                ...state,
                ...action.devInfo
            };
        }

        case UPDATE_CLIENT_DEV_INFO: {
            return {
                ...state,
                dbInfo: {
                    configuration: action.clientDev.configuration,
                    shard: action.clientDev.shard
                },
                clientId: action.clientDev.clientId,
                role: action.clientDev.role,
                operatorFeatures: action.clientDev.operatorFeatures,
                clientFeatures: action.clientDev.clientFeatures
            };
        }

        default: {
            return state;
        }
    }
}
